import { render, staticRenderFns } from "./AuthorizedPersonEditModal.vue?vue&type=template&id=3b24f61f&scoped=true&"
import script from "./AuthorizedPersonEditModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizedPersonEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedPersonEditModal.vue?vue&type=style&index=0&id=3b24f61f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24f61f",
  null
  
)

export default component.exports